import { useSession } from "../context/SessionContext";
import { permissions } from "../utils/permissions";

export const usePermissions = () => {
  const { roles } = useSession();

  return Object.fromEntries(
    Object.entries(permissions).map(([key, checkFn]) => [key, checkFn(roles)])
  );
};
